import useEventExtensionAppTools from './useEventExtensionAppTools';
import useEngagements from './useEngagements';

const useExtensionsAppTools = (eventUniqueName: string, sessionId: number) => {
    const eventExtensionTools = useEventExtensionAppTools(eventUniqueName);
    const sessionExtensionTools = useEngagements(eventUniqueName, sessionId);

    return [...eventExtensionTools, ...sessionExtensionTools];
};

export default useExtensionsAppTools;
